// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"b9b9aa91","160":"e2488e46","208":"3d0c1cb4","293":"e20e585e","453":"54292a4b","516":"9ae63e28","519":"61810f9d","917":"899a0d7e","946":"9c82c388"}[chunkId] + ".chunk.js";
};